module.exports = __webpack_public_path__ + "static/media/sfl_6.f2ad3ad4.jpg";